import React, { useState, useEffect } from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Slide from "@mui/material/Slide";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import Button from "@mui/material/Button";
import ButtonGroup from "@mui/material/ButtonGroup";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export default function MDComplaintStatusDialog({
  title,
  currentStatus,
  onAgree,
  customButton, // JSX element for the custom button
}) {
  const [open, setOpen] = useState(false);
  const [activeStatus, setActiveStatus] = useState("");

  useEffect(() => {
    setActiveStatus(currentStatus);
  }, [currentStatus]);

  const handleUpdateStatus = (status) => {
    setActiveStatus(status);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleAgree = () => {
    onAgree(activeStatus);
    handleClose();
  };

  return (
    <MDBox>
      <div onClick={handleOpen}>{customButton}</div>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
        maxWidth="lg"
      >
        <MDBox
          variant="gradient"
          bgColor="info"
          borderRadius="lg"
          coloredShadow="info"
          sx={{ padding: 5 }}
        >
          <DialogTitle id="responsive-dialog-title">
            <MDTypography
              variant="h6"
              color="white"
              fontWeight="medium"
              textTransform="capitalize"
            >
              {title}
            </MDTypography>
          </DialogTitle>
          <DialogContent>
            <DialogContentText>
              <MDTypography variant="button" fontWeight="regular" color="white">
                This Client will receive an email informing them of this
                complaint status update
              </MDTypography>
            </DialogContentText>
          </DialogContent>

          <MDBox
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 5,
              "& > *": {
                m: 1,
              },
            }}
          >
            <ButtonGroup
              orientation="horizontal"
              aria-label="vertical contained button group"
              variant="outlined"
              fullWidth
              color="white"
              size="large"
            >
              {/* {buttons} */}
              <Button
                key="pending"
                variant={activeStatus === "pending" ? "contained" : "outlined"}
              >
                <MDTypography
                  variant="h6"
                  color={activeStatus === "pending" ? "info" : "white"}
                  fontWeight="medium"
                  textTransform="capitalize"
                  onClick={() => handleUpdateStatus("pending")}
                >
                  Pending
                </MDTypography>
              </Button>
              <Button
                key="complaint_number_assigned"
                variant={
                  activeStatus === "complaint number assigned"
                    ? "contained"
                    : "outlined"
                }
              >
                <MDTypography
                  variant="h6"
                  color={
                    activeStatus === "complaint number assigned"
                      ? "info"
                      : "white"
                  }
                  fontWeight="medium"
                  textTransform="capitalize"
                  onClick={() =>
                    handleUpdateStatus("complaint number assigned")
                  }
                >
                  Complaint Number Assigned
                </MDTypography>
              </Button>
              <Button
                key="assessment_in_progress"
                variant={
                  activeStatus === "assessment in progress"
                    ? "contained"
                    : "outlined"
                }
              >
                <MDTypography
                  variant="h6"
                  color={
                    activeStatus === "assessment in progress" ? "info" : "white"
                  }
                  fontWeight="medium"
                  textTransform="capitalize"
                  onClick={() => handleUpdateStatus("assessment in progress")}
                >
                  Assessment In Progress
                </MDTypography>
              </Button>
              <Button
                key="approved"
                variant={activeStatus === "approved" ? "contained" : "outlined"}
              >
                <MDTypography
                  variant="h6"
                  color={activeStatus === "approved" ? "info" : "white"}
                  fontWeight="medium"
                  textTransform="capitalize"
                  onClick={() => handleUpdateStatus("approved")}
                >
                  Approved
                </MDTypography>
              </Button>
              ,
              <Button
                key="rejected"
                variant={activeStatus === "rejected" ? "contained" : "outlined"}
              >
                <MDTypography
                  variant="h6"
                  color={activeStatus === "rejected" ? "error" : "white"}
                  fontWeight="medium"
                  textTransform="capitalize"
                  onClick={() => handleUpdateStatus("rejected")}
                >
                  Rejected
                </MDTypography>
              </Button>
            </ButtonGroup>
          </MDBox>

          <DialogActions>
            <MDButton onClick={handleClose}>Disagree</MDButton>
            <MDButton disabled={!activeStatus} onClick={handleAgree}>
              Agree
            </MDButton>
          </DialogActions>
        </MDBox>
      </Dialog>
    </MDBox>
  );
}
